import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { ApiConfiguration } from '../api/platform/api-configuration';

@Injectable({ providedIn: 'root' })
export class TiendanubeAppService {
  constructor(
    private readonly http: HttpClient,
    private readonly platformApiConfig: ApiConfiguration
  ) {}

  async ensureWebhooks(storeId: string): Promise<void> {
    await lastValueFrom(
      this.http.post(
        `${this.platformApiConfig.rootUrl}/api/v1/tiendanube-app/webhooks/ensure`,
        null,
        { headers: { 'terrific-store-id': storeId } }
      )
    );
  }
}
